import "core-js";
import "regenerator-runtime/runtime";
//import 'vendor/scrollbar/jquery.mousewheel';
import SmallBasket from 'components/SmallBasket';

export default class SiteTemplate {
    constructor() {
        this.smallBasket = new SmallBasket;
        this.bind();
    }

    bind() {
        $('.modal').on('click', this.onModalOverlayClick.bind(this));
    }

    onModalOverlayClick(e) {
        console.log(e);
        if (e.target !== e.currentTarget) {
            return;
        }

        $('.modal').addClass('hidden');
    }
}
